import React from 'react';
import { useTranslation } from 'react-i18next';
import './BenefitsContainer.css';
import LeftElement from '../../assets/elements/left.png'; // Import your SVG
import RightElement from '../../assets/elements/right.png'; // Import your SVG
interface BenefitsContainerProps {
  benefitTitle: string[];
  description: string;
  benefits: string[];
}

const BenefitsContainer: React.FC<BenefitsContainerProps> = ({
  benefitTitle,
  description,
  benefits,
}) => {
  const { t } = useTranslation();

  return (
    <div className="benefits-container-parent">
      <img src={LeftElement} alt="Decorative Left Element" className="svg-element left" />
      <div className="benefits-container">
       
      <div className="benefits-content">
        <h2 className="benefits-title">{t("key_takeaways")}</h2>
        <p className="benefits-description">{description}</p>
        <ul className="benefits-list">
          {benefits.map((benefit, index) => (
            <li key={index} className="benefit-item">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p className="benefit-subti">
                  <span className="benefit-title">
                    {benefitTitle[index] || ''} &nbsp;
                  </span>
                  {benefit}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      
      
    </div>
    <img src={RightElement} alt="Decorative Right Element" className="svg-element right" />
    </div>
  );
};

export default BenefitsContainer;
